/**
 * Common
 */
export const SUCCESS = 'SUCCESS'
export const FAIL = 'FAIL'
export const LOADER = 'LOADER'

/**
 * Auth
 */
export const SMS_AUTH_SUCCESS = 'SMS_AUTH_SUCCESS'

/**
 * Works
 */
export const WORKS_SUCCESS = 'WORKS_SUCCESS'

/**
 * TALENT
 */
export const TALENT_SUCCESS = 'TALENT_SUCCESS'

/**
 * MergedNews
 */
export const MERGED_NEWS_SUCCESS = 'MERGED_NEWS_SUCCESS'

/**
 * tags
 */
export const TAGS = 'TAGS'
export const TAGS_ART = 'TAGS_ART'

/**
 * types
 */
export const WORK_MEDIA_TYPE = 'WORK_MEDIA_TYPE'
export const WORK_PROJECT_TYPE = 'WORK_PROJECT_TYPE'
export const STORIES_TAG = 'STORIES_TAG'
export const STORIES_PROJECT_TYPE = 'STORIES_PROJECT_TYPE'



// WEBPACK FOOTER //
// ./src/store/mutation-types/index.js